
import { additionalData } from '../configs/additional-data';

export const formatData = function(data, props){
    let dataFormated;
    if (Array.isArray(data)) {
        dataFormated = data.map(flattenObject);
    } else {
        dataFormated = [flattenObject(data)];
    }
    if (
        typeof additionalData[props.resource.name]?.additionalColumns ===
        'function'
    ) {
        dataFormated = dataFormated.map((item) => ({
            ...item,
            ...additionalData[props.resource.name].additionalColumns(item),
        }));
    }
    return dataFormated;
}

const flattenObject = function (ob) {
    const toReturn = {};
  
    for (const i in ob) {
      if (!ob.hasOwnProperty(i)) continue;
  
      if (ob[i] !== null && typeof ob[i] == 'object') {
        const flatObject = flattenObject(ob[i]);
        for (const x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;
  
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }
    return toReturn;
  };